import React from "react";
import "../styles/About.css";

function About() {
  return (
    <div className="about">
    </div>
  );
}

export default About;
